<template>
  <v-row>
    <v-col cols="12" md="4" >
      <v-radio-group v-model="value.tipo" row dense
        :rules="[
          this.$validators.string.required,
        ]">
        <v-radio
          label="Sintético"
          value="S"
        ></v-radio>
        <v-radio
          label="Analítico"
          value="A"
        ></v-radio>
      </v-radio-group>
    </v-col>
    <v-col cols="12" md="4">
      <v-switch
        v-model="value.flgEmpresaEstrangeira"
        true-value="S"
        false-value="N"
        label="Empresa estrangeira?"
        inset
      />
    </v-col>          
    <v-col cols="12" md="4">
      <v-switch
        v-model="value.esconderDados"
        :label="'Esconder dados sensíveis? (' + (value.esconderDados === 'S' ? 'Sim' : 'Não') + ') '"
        :true-value="'S'"
        :false-value="'N'"
        inset
      />
    </v-col>      
    <v-col cols="12" md="8">
      <v-text-field label="Razão Social/Nome Fantasia"
                    dense
                    v-model.trim="value.nome"/>
    </v-col>  
    <v-col cols="12" md="4">
      <v-text-field label="CNPJ"
                    dense
                    placeholder="99.999.999/9999-99"
                    v-mask="'##.###.###/####-##'"
                    v-model.trim="value.cnpj"/>
    </v-col>
    <v-col cols="12" sm="3">
      <lookup-dominio 
        label="Status" 
        :hidden-clear="false"
        v-model="value.flgStatus"
        :type="lookups.status"/>
    </v-col>    
    <v-col cols="12" sm="3">
      <lookup-dominio 
        label="Estado"
        :hidden-clear="false"
        v-model="value.estado"
        :type="lookups.estado"/>
    </v-col>  
    <v-col cols="12" md="6">
      <search-box
          label="Atividade Econômica"
          popup-label="Selecione um Atividade Econômica"
          :id.sync="value.idAtividadeEconomica"
          :descricao.sync="value.descricaoAtividadeEconomica"
          :hidden-clear="false"
          :value="atividadeEconomica"
          :loader-fn="loadeAtividadeEconomica"
          item-key="id"
          item-text="descricao">
        <template v-slot:empty>
          <p class="ma-2">
            Nenhum Atividade Econômica encontrado
          </p>
        </template>
      </search-box>
    </v-col>   
    <v-col cols="12" sm="6">
      <v-text-field label="Data Inicio Cadastro"
          dense
          type="date"
          v-model="value.dtInicio"
          :rules="[
              v => this.$validators.string.lessThanOrEquals(v, 10)
          ]"/>
    </v-col>
    <v-col cols="12" sm="6">
      <v-text-field label="Data Fim Cadastro"
            dense
            type="date"
            v-model="value.dtFim"
            :rules="[
                v => this.$validators.string.lessThanOrEquals(v, 10)
            ]"/>
    </v-col> 
  </v-row>
</template>

<script>

import {ItemDeDominio} from "../../../../api/itemsDominio";
import LookupDominio from "../../common/LookupDominio";
import OrderInput from "../../common/OrderInput";
import SearchBox from "../../common/SearchBox";
//PKs
import {findAll as findAllAtividadeEconomica} from "@/api/atividadeEconomica";

export default {
  name: "RelatorioCompradorForm",
  components: {
    SearchBox,
    LookupDominio,
    OrderInput
  },
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      lookups: {
        estado: ItemDeDominio.COMBO_ESTADO, 
        status: ItemDeDominio.STATUS_MODERACAO,
      },
    }
  },
  watch: {
  },
  computed: {
    atividadeEconomica(){
      if (this.value.idAtividadeEconomica == null) return null;
      return {
        id: this.value.idAtividadeEconomica,
        descricao: this.value.descricaoAtividadeEconomica
      }      
    },
  },
  methods: {
    loadeAtividadeEconomica(page, search) {
      return findAllAtividadeEconomica(page, {
        nome: search
      })
    },
  }
}
</script>

<style scoped lang="scss">

</style>